import styled, { css } from "styled-components";
import { Box } from "../UI/Box";
import { P } from "../Library/Typeography";

export const TabItem = styled(Box)<{ isActive: boolean }>`
  cursor: pointer;
  width: 60px;
  max-width: 60px;
  padding-bottom: 8px;
  position: relative;

  ${({ isActive }) => isActive && `
    cursor: default;
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 44px;
      border-radius: 30px;
      border-bottom: 2px solid var(--surface-brand, #FF0);
    }
  `}

  ${({ isActive }) => !isActive && css`
    &:hover {
      ${P} {
        color: var(--text-primary, #FFF);
      }
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 44px;
        border-radius: 30px;
        border-bottom: 2px solid var(--surface-minimal-alpha-tertiary, rgba(255, 255, 255, 0.40));
      }
    }
  `}
`
